import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@material-ui/core';
import { DefaultTheme } from '@material-ui/styles';
import { getSizeByPage } from '../utils/getSizeByPage';
import useVenueRoute from 'hooks/useVenueUrl/useVenueRoute';

export const useNotificationSize = () => {
    const [isLargeNotification, setIsLargeNotification] = useState(true);
    const [userMinimized, setUserMinimized] = useState(false);
    const isDesktop = useMediaQuery<DefaultTheme>(theme => theme.breakpoints.up('sm'));
    const location = useLocation();
    const baseRoute = useVenueRoute('');
    const currPageNotificationSize = getSizeByPage(location.pathname, baseRoute);

    useEffect(() => {
        const isLarge = currPageNotificationSize === 'large' && isDesktop && !userMinimized;
        setIsLargeNotification(isLarge);
    }, [location.pathname, isDesktop, userMinimized, setIsLargeNotification]);

    return {
        isLargeNotification,
        setUserMinimized,
        isDesktop,
    };
};
